import React, { useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useForm } from "react-hook-form";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { updatePersonalDetails } from "../../../helpers/urlConfig/apiFunctions";
import { successToastify } from "../../../Components/Common/Toaster";
import { getSessionData } from "../../../helpers/sessionDetailsParser";
import errorResponseHandler from "../../../helpers/errorResponseHandler";

function PersonalDetailsEdit({
  modal_list,
  setmodal_list,
  tog_list,
  fetchData,
  editPersonalData,
}) {
  const { register, handleSubmit, reset, setValue } = useForm({
    defaultValues: editPersonalData,
  });

  const [logoPreview, setLogoPreview] = useState(editPersonalData?.logo || "");

  // Handle Image Selection
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setLogoPreview(reader.result); // Preview Image
        setValue("logo", reader.result); // Set Base64 Image in Form
      };
      reader.readAsDataURL(file);
    }
  };

  const onSubmit = async (data) => {
    try {
      data.updated_by = getSessionData("user_id");
      const response = await updatePersonalDetails(data);
      if (response.statusCode === 200) {
        successToastify("Personal Details updated successfully");
        fetchData();
        setmodal_list(false);
        reset();
      } else {
        errorResponseHandler(response);
      }
    } catch (error) {
      console.error("Error updating personal details:", error);
    }
  };

  return (
    <>
      <ToastContainer />
      <Modal isOpen={modal_list} toggle={tog_list} centered>
        <ModalHeader className="bg-light p-3" toggle={tog_list}>
          Edit Personal Info
        </ModalHeader>
        <form className="tablelist-form" onSubmit={handleSubmit(onSubmit)}>
          <ModalBody>
            {/* Owner Name */}
            <div className="mb-3">
              <label className="form-label">Owner Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Owner Name"
                required
                {...register("name", { required: "Owner Name is required" })}
              />
            </div>

            {/* Bank Name */}
            <div className="mb-3">
              <label className="form-label">Bank Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Bank Name"
                required
                {...register("bank", { required: "Bank is required" })}
              />
            </div>

            {/* Account Number */}
            <div className="mb-3">
              <label className="form-label">Account Number</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Account Number"
                required
                {...register("acc_no", {
                  required: "Account Number is required",
                })}
              />
            </div>

            {/* IFSC Code */}
            <div className="mb-3">
              <label className="form-label">IFSC Code</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter IFSC Code"
                {...register("ifsc_code")}
              />
            </div>

            {/* Branch */}
            <div className="mb-3">
              <label className="form-label">Branch</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Branch"
                {...register("branch")}
              />
            </div>

            {/* Logo Upload */}
            <div className="mb-3">
              <label className="form-label">Logo</label>
              <input
                type="file"
                className="form-control"
                accept="image/*"
                onChange={handleImageChange}
              />
              {logoPreview && (
                <div className="mt-2">
                  <p>Preview:</p>
                  <img src={logoPreview} alt="Logo Preview" width="100" />
                </div>
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-light"
              onClick={() => setmodal_list(false)}
            >
              Close
            </button>
            <button type="submit" className="btn btn-success">
              Edit Personal Info
            </button>
          </ModalFooter>
        </form>
      </Modal>
    </>
  );
}

export default PersonalDetailsEdit;
